/* Mint-JobNew: form tạo job. Màu chỉ var(--…). */
.page { display: flex; flex-direction: column; gap: 12px; padding: 0 0 24px; min-width: 0; }
.bar { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 12px; }
.cols { display: grid; grid-template-columns: minmax(0, 1fr) 380px; gap: 16px; align-items: start; }
.form { display: flex; flex-direction: column; gap: 14px; min-width: 0; }
.side { display: flex; flex-direction: column; gap: 14px; position: sticky; top: 12px; }
.card { padding: 16px 18px 18px; border-radius: 16px; background: var(--card); box-shadow: var(--sh); }
.h { margin: 0; font-size: 16px; font-weight: var(--fw-title); line-height: 1.25; }
.head { display: flex; align-items: center; gap: 8px; min-height: 32px; margin-bottom: 8px; color: var(--tx2); }
.head .h { color: var(--tx); }
.miss { padding: 2px 8px; border-radius: 999px; font-size: 12px; font-weight: var(--fw-label); background: var(--err-bg); color: var(--err); }
.fold { margin-left: auto; display: flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 0; border-radius: 9px; background: transparent; color: var(--tx2); cursor: pointer; }
.after { display: flex; flex-direction: column; gap: 8px; margin: 0; }
.after div { display: flex; gap: 8px; font-size: 12px; }
.after dt { width: 40px; flex-shrink: 0; font-weight: 600; color: var(--lb); }
.after dd { margin: 0; color: var(--tx2); }
.foot { position: sticky; bottom: 0; display: flex; align-items: center; justify-content: flex-end; gap: 10px; padding: 12px 24px; border-top: 1px solid var(--line); background: var(--card); }
.footWarn, .footOk { margin-right: auto; font-weight: var(--fw-label); }
.footWarn { color: var(--warn); }
.footOk { color: var(--ok); }
.grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px 14px; }
.cell { min-width: 0; }
.lbl { margin-bottom: 6px; font-size: 12px; font-weight: var(--fw-label); color: var(--tx2); }
.req { color: var(--err); }
.err { margin-top: 4px; font-size: 12px; color: var(--err); }
.chk { display: flex; align-items: center; gap: 8px; align-self: end; height: 36px; font-size: 13px; cursor: pointer; }
.chk input { width: 16px; height: 16px; margin: 0; accent-color: var(--pri); }
.sum { display: flex; flex-direction: column; gap: 8px; margin: 12px 0 0; }
.sum div { display: flex; justify-content: space-between; gap: 12px; font-size: 13px; }
.sum dt { color: var(--lb); }
.sum dd { margin: 0; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-weight: var(--fw-label); text-align: right; }
.check { display: flex; align-items: flex-start; gap: 8px; margin-top: 10px; padding: 8px 10px; border-radius: 10px; font-size: 13px; }
.checkWarn { background: var(--warn-bg); color: var(--warn); }
.checkOk { background: var(--ok-bg); color: var(--ok); }
@media (max-width: 1279px) {
  .page { padding: 0 20px 20px; }
  .cols { grid-template-columns: minmax(0, 1fr); }
  .side { position: static; order: -1; flex-direction: row; flex-wrap: wrap; }
  .side > * { flex: 1 1 280px; }
}
@media (max-width: 767px) {
  .page { padding: 0 12px 16px; }
  .grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .cell { grid-column: span 2 !important; }
}

.segWrap { max-width: 100%; overflow-x: auto; scrollbar-width: none; }
@media (max-width: 767px) {
  .hideSm { display: none; }
  .side { order: 1; }
}
.barLbl { font-size: 12px; font-weight: var(--fw-label); color: var(--tx2); }

/* start=chat (Mint-JobNew › Tạo từ chat Ask HANA) */
.tip { display: inline-flex; color: var(--lb); cursor: help; }
.chat { display: flex; flex-direction: column; gap: 10px; }
.chatMsg { width: 100%; box-sizing: border-box; padding: 10px 12px; border-radius: 10px; border: 1px solid var(--bd); background: var(--sub); color: var(--tx); font: inherit; resize: none; }
.chips { display: flex; flex-wrap: wrap; gap: 6px; }
.chip { padding: 3px 9px; border-radius: 999px; background: var(--pri-bg); color: var(--link); font-size: 12px; font-weight: var(--fw-label); }
.dupBox { display: flex; flex-direction: column; gap: 4px; padding: 10px 12px; border-radius: 10px; background: var(--warn-bg); }
.dupBox b { font-weight: var(--fw-label); color: var(--warn); }
.dupRow { display: flex; align-items: center; gap: 10px; font-size: 12px; }
.dupHard, .dupSoft { width: 150px; flex-shrink: 0; font-weight: var(--fw-label); }
.dupHard { color: var(--err); }
.dupSoft { color: var(--warn); }
.dupVal { flex-grow: 1; color: var(--tx2); }
.dupLink { display: inline-flex; align-items: center; gap: 6px; color: var(--link); font-weight: var(--fw-label); text-decoration: none; }
.noDup { padding: 8px 12px; border-radius: 10px; background: var(--ok-bg); color: var(--ok); font-weight: var(--fw-label); }
.chatAct { display: flex; justify-content: flex-end; gap: 8px; }

/* start=multi (Mint-JobNew › Đặt nhiều booking một lúc) */
.mbSum { margin-left: 8px; font-size: 12px; color: var(--lb); }
.mb { display: flex; flex-direction: column; gap: 10px; }
.mbSeg { align-self: flex-start; display: flex; padding: 3px; border-radius: 10px; background: var(--ctl); }
.mbSegBtn { height: 28px; padding: 0 10px; border: 0; border-radius: 8px; background: transparent; color: var(--tx2); font: inherit; font-size: 12px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.mbSegOn { background: var(--card); color: var(--tx); box-shadow: var(--sh); }
.mbTbl { width: 100%; border-collapse: collapse; }
.mbTbl th { height: 34px; text-align: left; font-size: 12px; font-weight: 500; color: var(--lb); }
.mbTbl td { height: 44px; border-top: 1px solid var(--line); }
.mbTbl b { font-weight: var(--fw-label); }
.mbOn { background: color-mix(in srgb, var(--pri-bg) 45%, var(--card)); }
.mbChk { width: 36px; }
.mbChk input { width: 16px; height: 16px; margin: 0; accent-color: var(--pri); }
.mbQty { width: 140px; }
.mbCut, .mbSvc { color: var(--tx2); }
.mbSoon { color: var(--err); }
.mbStep { display: inline-flex; align-items: center; border-radius: 9px; background: var(--ctl); }
.mbStep button { width: 30px; height: 30px; border: 0; background: transparent; color: var(--tx); font: inherit; cursor: pointer; }
.mbStep b { width: 28px; text-align: center; }
